import styled from 'styled-components';
import { breakpoint } from '../../theme';
import { LinkText, UIText } from '../typography';

export const AuctionSalesItemContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  align-items: flex-start;
  gap: 16px;
  border: 1px solid purple;
  border-color: ${({ theme }) => theme.colors.neutrals.solidGrays[5]};
  border-radius: 8px;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px 16px;
  width: 100%;
  ${breakpoint('xs', 'sm')`
    flex-direction: column;
    `};
`;
export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  gap: 8px;
`;

const columnPins = (highlighted?: boolean) =>
  `
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    div:nth-child(2){
      ${
        highlighted
          ? `
        margin-top: 0;
        margin-left: 0;`
          : `
        margin-top: -4px;
        margin-left: 4px; `
      };
    }
  `;

export const Pins = styled.div<{ highlighted?: boolean }>`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-left: -2px;

  ${({ highlighted }) => breakpoint('xs', 'sm')`${columnPins(highlighted)}`};
  ${({ highlighted }) => breakpoint('md', 'lg')`${columnPins(highlighted)}`};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 16px;
  div:first-child {
    width: max-content;
  }
  ${breakpoint('xs', 'sm')`
      margin-left: 0px;
      div:first-child {
        width : 100%;
      }
  `};
`;

export const ImageRow = styled.a`
  width: 100%;
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;

  img {
    scroll-snap-align: start;
    border: 1px solid ${({ theme }) => theme.colors.neutrals.solidGrays[6]};
    object-fit: contain;
    border-radius: 4px;
    min-width: 200px;
    max-width: 200px;
    height: 144px;

    ${breakpoint('sm')`
      min-width: 224px;
      max-width: 224px;
      height: 150px;
    `};
  }

  ${breakpoint('sm', 'md')`
    img:nth-child(4) {
      display: none;
    }
  `};
`;

export const Title = styled(LinkText).attrs({ size: 'lg' })`
  ${({ theme }) => theme.typography.uiText.lg};
  color: ${({ theme }) => theme.colors.primary.graysGray} !important;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 28px;
  margin-right: ${({ theme }) => theme.spacings[2].rem};
  margin-bottom: ${({ theme }) => theme.spacings[2].rem};
  ${breakpoint('sm')`
      margin-bottom: 0;
   `}
`;

// Lcoation Pin
export const PinContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: max-content;
  padding: 4px 0;
`;

export const TimerContainer = styled.div`
  padding: 4px;
  border-radius: 4px;
  background-color: rgba(0, 133, 59, 0.08);
  color: ${({ theme }) => theme.colors.system.systemGreen};
`;

export const StyledSaleLink = styled.a`
  ${({ theme }) => theme.typography.uiText.sm};
  color: ${({ theme }) => theme.colors.system.systemBlue};
  display: flex;
  gap: ${({ theme }) => theme.spacings[2].rem};
`;

export const IconText = styled(UIText)`
  text-overflow: ellipsis;
`;
